export const SET_MESSAGE_NOTIFICATION_ACTION_TYPE = 'SET_MESSAGE_NOTIFICATION_TYPE';

export const setMessage = ({ message, duration = 2000 }) => ({
  type: SET_MESSAGE_NOTIFICATION_ACTION_TYPE,
  payload: { message, duration },
});
